import { render } from "./CriteoLogoIcon.vue?vue&type=template&id=5c631938"
import script from "./CriteoLogoIcon.vue?vue&type=script&lang=js"
export * from "./CriteoLogoIcon.vue?vue&type=script&lang=js"

import "./CriteoLogoIcon.vue?vue&type=style&index=0&id=5c631938&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__